/** @jsxImportSource @emotion/react */
"use client";
import { useTranslations } from "@i18n/react";
import { useAddToQueue } from "@packages/media";
import type { AppQueueContentType } from "@packages/sdk";

import {
  PlayLastIcon,
  PlayNextIcon,
} from "../../../_base/icons/Icon/MediaIcons";
import { DropdownMenuItem } from "../../../_base/modals/DropdownMenuItem/DropdownMenuItem.emotion";

export type AddToQueueProps = {
  type: AppQueueContentType;
  id: number;
};

export const AddToQueue = ({ type, id }: AddToQueueProps) => {
  const { handleClickNext, handleClickLast, stringKeyNext, stringKeyLast } =
    useAddToQueue({ type, id });
  const t = useTranslations();

  return (
    <>
      <DropdownMenuItem onClick={handleClickNext} startIcon={<PlayNextIcon />}>
        {t(stringKeyNext)}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={handleClickLast} startIcon={<PlayLastIcon />}>
        {t(stringKeyLast)}
      </DropdownMenuItem>
    </>
  );
};
